<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { getStore } from "@/utils/localStorage";
export default {
  name: "app",
  created() {
    if (getStore("token")) {
      // this.$store.dispatch("common/getCosAction"); // 获取腾讯云签名
      this.$store.dispatch("common/getS3ClientAction"); // 获取天翼云签名
      // if(this.$store.state.permission._ENTRANCETYPE === 'adult'){
      //   this.$store.dispatch("common/getStartYearList"); // 获取学年
      // }
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/_reset.scss"; //样式重置
#app {
  width: 100%;
  height: 100%;
  min-width: 1360px;
  overflow: hidden;
  overflow-x: auto;
  font-size: $baseFontSize; /* 0 */
}
.myClassTab .el-tabs__nav-wrap {
  padding: 0 40px;
}
.readListDiv .el-progress-circle {
  width: 100px !important;
  height: 100px !important;
  font-size: 20px !important;
}
.impowerBox .title {
  display: none;
}
.dialogFace .el-dialog--center {
  margin-top: 9vh !important;
}
.wxBind .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}
// .classServiceInfo .el-input__inner {
//   border-style: none !important;
//   background-color: rgba(0, 0, 0, 0) !important;
// }
// .classServiceInfo .el-carousel__container {
//   height: 100vh !important;
// }
// .classServiceInfo .el-table th {
//   text-align: center !important;
// }
// .classServiceInfo .el-input__inner {
//   text-align: center !important;
// }
.answerListInput .el-input__inner {
  width: 100% !important;
  height: 60px !important;
  text-align: center !important;
  border-style: none !important;
  background-color: #fe7847 !important;
  font-size: 40px !important;
  color: #fff !important;
  font-weight: bold !important;
  padding: 0 !important;
  &::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #fff;
    font-size: 12px;
    opacity: 0.4;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #fff;
    font-size: 12px;
  }

  &::-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #fff;
    font-size: 12px;
  }
}
.upDataIDDiv .el-loading-spinner {
  top: 25%;
}
.disabled-btn-span span {
  margin-left: 5px;
}
.disabled-btn-span i {
  margin-top: -2px;
  display: inline-block;
}
.titleTab {
  #tab-intelligent_exercise {
    padding-left: 20px !important;
  }
  .el-tabs__nav {
    height: 45px !important;
  }
  .el-tabs__nav .el-tabs__item {
    font-size: 16px !important;
  }
}
.onlineTestData .topicDt p p span {
  background-color: #f8f8f8 !important;
}
//.smartDisorderlyUl label{width: 100%;
//  .el-checkbox__label{width: 100%;overflow: hidden;text-overflow: ellipsis;display: inline-block}
//}
.ql-align-center {
  text-align: center;
}
.ql-align-right {
  text-align: right;
}

.el-image-viewer__close {
  color: #fff;
}
.real-test-list .el-collapse-item__header {
  height: auto !important;
  line-height: normal;
}
</style>


